var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { t } from '@mp/locale';
import { AppPropsContext } from "../../hooks/AppPropsContext";
import { OrderContext } from "../../hooks/OrderContext";
import { isNotSpacesOnly } from "../../utils/validation";
export default function SignUpForm(_a) {
    var country = _a.country, onBackButtonClicked = _a.onBackButtonClicked;
    var _b = useState(false), signUpFormSent = _b[0], setSignUpFormSent = _b[1];
    var _c = useContext(AppPropsContext), userContactInfo = _c.userContactInfo, onSignUpFormSubmit = _c.onSignUpFormSubmit;
    var order = useContext(OrderContext).order;
    var emptyAddress = {
        street_address_lines: ["", ""],
        administrative_area: undefined,
        locality: undefined,
        dependent_locality: undefined,
        postal_code: undefined,
        country: country,
    };
    var getDefaultValues = function () {
        var defaultValues = {};
        if (userContactInfo) {
            defaultValues = {
                first_name: userContactInfo.contact_first_name,
                last_name: userContactInfo.contact_last_name,
                email: userContactInfo.contact_email,
            };
        }
        return __assign({ first_name: "", last_name: "", email: "" }, defaultValues);
    };
    var _d = useForm({
        mode: "onChange",
        defaultValues: getDefaultValues(),
    }), register = _d.register, handleSubmit = _d.handleSubmit, watch = _d.watch, isValid = _d.formState.isValid;
    var onSubmit = function (data) {
        data.address = emptyAddress;
        if (userContactInfo) {
            data.first_name = userContactInfo.contact_first_name;
            data.last_name = userContactInfo.contact_last_name;
            data.email = userContactInfo.contact_email;
        }
        onSignUpFormSubmit(data).then(function (_) {
            setSignUpFormSent(true);
        });
    };
    var isValidForm = function () {
        return (userContactInfo ||
            (isValid &&
                isNotSpacesOnly(watch("first_name")) &&
                isNotSpacesOnly(watch("last_name")) &&
                isNotSpacesOnly(watch("email"))));
    };
    return (_jsxs(_Fragment, { children: [!signUpFormSent && (_jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("h1", __assign({ className: "notify-title" }, { children: [" ", t("CAPTURE_SERVICES.SIGNUP.ACTIONS.notifyMe"), " "] })), _jsx("h1", __assign({ className: "notify-msg" }, { children: " We'll notify you when coverage is available in that area. " })), !userContactInfo && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "mp-form-row" }, { children: [_jsx(TextField, __assign({ variant: "standard", className: "mp-form-input", id: "first_name", name: "first_name", label: t("CAPTURE_SERVICES.SIGNUP.LABELS.first_name") }, register("first_name", { required: true }))), _jsx(TextField, __assign({ variant: "standard", className: "mp-form-input", id: "last_name", name: "last_name", label: t("CAPTURE_SERVICES.SIGNUP.LABELS.last_name") }, register("last_name", { required: true })))] })), _jsx("div", __assign({ className: "mp-form-row" }, { children: _jsx(TextField, __assign({ variant: "standard", className: "mp-form-row-input", id: "email", name: "email", label: t("CAPTURE_SERVICES.SIGNUP.LABELS.email"), type: "email" }, register("email", { required: true }))) }))] })), _jsxs("div", __assign({ className: "mp-capturesvc-button-container" }, { children: [_jsx("button", __assign({ type: "submit", className: "button-new" }, { children: t("CAPTURE_SERVICES.SIGNUP.ACTIONS.notifyMe") })), _jsx("button", __assign({ className: "button-new-inverted", type: "button", onClick: onBackButtonClicked }, { children: t("CAPTURE_SERVICES.SIGNUP.ACTIONS.checkAnother") }))] }))] }))), signUpFormSent && (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "notify-msg" }, { children: " Thank you! We'll let you know when we're available in that area. " })), _jsx("div", __assign({ className: "mp-capturesvc-button-container" }, { children: _jsx("button", __assign({ className: "button-new-inverted", onClick: onBackButtonClicked, type: "button" }, { children: t("CAPTURE_SERVICES.SIGNUP.ACTIONS.checkAnother") })) }))] }))] }));
}
